import styled from 'styled-components';
import { EllipsisTooltip } from '@components/common';
import { Space } from 'antd';
import { Category } from '../utils';

export const RealtimeTileWrapper = styled.div`
  padding: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const BarTileChartWrapper = styled.div`
  width: 100%;
  height: 70%;
  position: relative;
  background-color: #f6f6f6;
  border-radius: 4px;
  cursor: pointer;
`;

export const RealtimeNumber = styled.div<{ $critical: Category }>`
  position: relative;
  text-align: right;
  padding: 8px 8px 0 0;
  color: ${({ $critical }) => {
    switch ($critical) {
      case Category.Critical:
        return '#d5021b';
      default:
        return '#686868';
    }
  }};
`;
export const RealtimeBarTileValue = styled.span`
  font-size: 30px;
  font-weight: 500;
`;

export const RealtimeBarTileUnit = styled.span`
  margin-left: 4px;
  font-size: 18px;
  font-weight: 400;
  line-height: 48px;
`;

const formatPercentage = (value: number, max: number) => {
  const percent = value / max;
  if (isNaN(percent)) {
    return '0px';
  }
  return `${Math.floor((percent > 1 ? 1 : percent) * 100)}%`;
};

export const Bar = styled.div<{ $value: number; $max: number; $critical: Category }>`
  width: ${({ $value, $max }) => formatPercentage($value, $max)};
  height: 100%;
  background-color: ${({ $critical }) => {
    switch ($critical) {
      case Category.Critical:
        return '#ffe2de';
      case Category.Warning:
        return '#fbf3a5';
      default:
        return '#c9f1c1';
    }
  }};
  position: absolute;
  bottom: 0;
  transition: all 0.3s;
`;
export const ThresholdIndicator = styled.div<{ $threshold: number; $max: number }>`
  position: absolute;
  border-left: 2px solid #686868;
  outline: 2px solid #fff;
  border-radius: 2px;
  height: 15px;
  left: ${({ $threshold, $max }) => formatPercentage($threshold, $max)};
  bottom: -3px;

  &::after {
    content: '▲';
    color: #686868;
    position: absolute;
    left: -6px;
    top: 8px;
    font-size: 10px;
  }
`;
